/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerCustomerDemoRoutingModule
 * Purpose		: Routing module for CustomerCustomerDemo.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CustomerCustomerDemoListComponent } from './CustomerCustomerDemoList.component';
import { CustomerCustomerDemoAddComponent }  from './CustomerCustomerDemoAdd.component';
import { CustomerCustomerDemoEditComponent } from './CustomerCustomerDemoEdit.component';
import { CustomerCustomerDemoDetailsComponent } from './CustomerCustomerDemoDetails.component';

const CustomerCustomerDemoRoutes: Routes = [
	{ path: 'CustomerCustomerDemo',  component: CustomerCustomerDemoListComponent },
	{ path: 'CustomerCustomerDemo/add', component: CustomerCustomerDemoAddComponent },
	{ path: 'CustomerCustomerDemo/:id', component: CustomerCustomerDemoEditComponent },
	{ path: 'CustomerCustomerDemo/Details/:id', component: CustomerCustomerDemoDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(CustomerCustomerDemoRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class CustomerCustomerDemoRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CustomerCustomerDemo/CustomerCustomerDemo-routing.module.ts